export const setSecureVaultOn = (payload) => ({
  type: 'SET_SECURE_VAULT_ON',
  payload,
});

export const setSecureVaultOff = () => ({
  type: 'SET_SECURE_VAULT_OFF',
});
